import { render, staticRenderFns } from "./GreetingCards.vue?vue&type=template&id=185738f3&scoped=true"
import script from "./GreetingCards.vue?vue&type=script&lang=js"
export * from "./GreetingCards.vue?vue&type=script&lang=js"
import style0 from "./GreetingCards.vue?vue&type=style&index=0&id=185738f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185738f3",
  null
  
)

export default component.exports